import * as React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography, Grid, Divider, styled } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { copy } from 'src/utils/dom';
import Column from 'src/frontend-common/components/Column';
import Paper from 'src/components/Paper';
import SnackBarCustom from 'src/frontend-common/components/SnackbarCustom';
import ButtonComponent from 'src/components/ButtonComponent';
import CopyContentIcon from '@mui/icons-material/ContentCopy';

interface Props {
  appKey: string;
  open: boolean;
  onClose: () => void;
}

const Wrapper = styled(Paper)(() => ({
  position: 'relative',
}));

const CodeWrapper = styled(Column)(() => ({
  overflowY: 'scroll',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
}));

const Code = styled('pre')(({ theme }) => ({
  color: '#263238',
  margin: 0,
  borderWidth: 0,
  backgroundColor: theme.palette.background.default,
  borderRadius: '4px',
  padding: `${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(4)}px`,
  fontSize: '14px',
}));

const Footer = styled(DialogActions)(({ theme }) => ({
  padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
}));

export const AppCodeModal: React.FC<Props> = ({ appKey, open, onClose }) => {
  const codeRef = React.useRef<HTMLPreElement | null>(null);
  const [showSnackBar, setShowSnackBar] = React.useState(false);

  const codeText = `<script>
   (function(f,i,d,o,c,od,e){f['FidoObject']=c;f[c]=f[c]||function(){
        (f[c].q=f[c].q||[]).push(arguments)},f[c].l=1*new Date();od=i.createElement(d),
        e=i.getElementsByTagName(d)[0];od.async=1;od.src=o;e.parentNode.insertBefore(od,e)
   })(window,document,'script','https://code.fido.id/fd.js','fido');
        
   fido('create', '${appKey}');
</script>`;

  return (
    <>
      <Dialog maxWidth="lg" open={open} onClose={onClose}>
        <DialogTitle>
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography variant="h4">JavaScript snippet</Typography>
            <ButtonComponent icon={<CloseIcon />} buttontype="icon" onClick={onClose} />
          </Grid>
        </DialogTitle>

        <Divider light />

        <DialogContent>
          <Wrapper>
            <CodeWrapper>
              <Code ref={codeRef}>{codeText}</Code>
            </CodeWrapper>
          </Wrapper>
        </DialogContent>

        <Divider light />

        <Footer>
          <ButtonComponent
            buttontype="icon"
            onClick={() => {
              if (codeRef.current !== null) {
                copy(codeRef.current);
                setShowSnackBar(true);
              }
            }}
            icon={<CopyContentIcon />}
          />
        </Footer>
      </Dialog>
      <SnackBarCustom open={showSnackBar} message="snippet copied to clipboard!" onClose={() => setShowSnackBar(false)} severity="success" />
    </>
  );
};
